__turbopack_context__.v({
  "deskriptor": "hero-block-module-scss-module__9onwdq__deskriptor",
  "heroBgImage": "hero-block-module-scss-module__9onwdq__heroBgImage",
  "heroblock": "hero-block-module-scss-module__9onwdq__heroblock",
  "herocontainer": "hero-block-module-scss-module__9onwdq__herocontainer",
  "strapiBlogHero": "hero-block-module-scss-module__9onwdq__strapiBlogHero",
  "text": "hero-block-module-scss-module__9onwdq__text",
  "title": "hero-block-module-scss-module__9onwdq__title",
  "upliftCard": "hero-block-module-scss-module__9onwdq__upliftCard",
  "upliftTitle": "hero-block-module-scss-module__9onwdq__upliftTitle",
});
